webpackJsonp([114276838955818,60335399758886],{

/***/ 277:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(609);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(277);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  color: #ffffff;\n  text-align: center;\n  width: 100%;\n  margin-top: auto;\n  padding: 15px 15px 40px 15px !important;\n  img {\n    max-width: 50px;\n    margin: auto;\n  }\n'], ['\n  background-color: ', ';\n  color: #ffffff;\n  text-align: center;\n  width: 100%;\n  margin-top: auto;\n  padding: 15px 15px 40px 15px !important;\n  img {\n    max-width: 50px;\n    margin: auto;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-decoration: underline;\n'], ['\n  text-decoration: underline;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styledComponents = __webpack_require__(87);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(72);
	
	var palette = _interopRequireWildcard(_variables);
	
	var _SiteConfig = __webpack_require__(47);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _semanticUiReact = __webpack_require__(46);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	/** Style **/
	
	
	var Footer = _styledComponents2.default.footer(_templateObject, palette.DARK_GRAY);
	
	var Liens = _styledComponents2.default.a(_templateObject2);
	
	var propTypes = {
	  data: PropTypes.object
	};
	
	var C_Footer = function (_React$Component) {
	  _inherits(C_Footer, _React$Component);
	
	  function C_Footer() {
	    _classCallCheck(this, C_Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  C_Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      Footer,
	      { className: 'ui fluid container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui container' },
	        _react2.default.createElement(
	          'p',
	          { className: 'typo__8' },
	          _SiteConfig2.default.copyright,
	          _react2.default.createElement(
	            _semanticUiReact.Responsive,
	            { as: 'span', minWidth: 640 },
	            ' ',
	            '| Site d\xE9velopp\xE9 avec',
	            ' ',
	            _react2.default.createElement(
	              Liens,
	              {
	                href: 'https://www.contentful.com/',
	                rel: 'nofollow',
	                target: '_blank'
	              },
	              'Contentful'
	            ),
	            ',',
	            ' ',
	            _react2.default.createElement(
	              Liens,
	              {
	                href: 'https://www.netlify.com/',
	                rel: 'nofollow',
	                target: '_blank'
	              },
	              'Netlify'
	            ),
	            ',',
	            ' ',
	            _react2.default.createElement(
	              Liens,
	              {
	                href: 'https://www.gatsbyjs.org/',
	                rel: 'nofollow',
	                target: '_blank'
	              },
	              'Gatsby JS'
	            ),
	            ',',
	            ' ',
	            _react2.default.createElement(
	              Liens,
	              { href: 'https://reactjs.org/', rel: 'nofollow', target: '_blank' },
	              'React JS'
	            ),
	            ',',
	            ' ',
	            _react2.default.createElement(
	              Liens,
	              {
	                href: 'https://react.semantic-ui.com/',
	                rel: 'nofollow',
	                target: '_blank'
	              },
	              'Semantic-UI React'
	            ),
	            ' ',
	            'et',
	            ' ',
	            _react2.default.createElement(
	              Liens,
	              { href: 'https://github.com/', rel: 'nofollow', target: '_blank' },
	              'Github'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              compact: true,
	              color: 'grey',
	              as: 'a',
	              href: 'https://github.com/mass22/',
	              target: '_blank'
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'github' }),
	            ' Github'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              compact: true,
	              color: 'linkedin',
	              as: 'a',
	              href: 'https://www.linkedin.com/in/russomassimo',
	              target: '_blank'
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkedin' }),
	            ' Linkedin'
	          )
	        )
	      )
	    );
	  };
	
	  return C_Footer;
	}(_react2.default.Component);
	
	C_Footer.propTypes = propTypes;
	
	exports.default = C_Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 1.5em;\n  background-color: ", ";\n  color: ", ";\n  border-bottom: ", " 4px solid;\n  position: relative;\n  a {\n    display: inline-flex;\n    align-items: center;\n  }\n"], ["\n  font-size: 1.5em;\n  background-color: ", ";\n  color: ", ";\n  border-bottom: ", " 4px solid;\n  position: relative;\n  a {\n    display: inline-flex;\n    align-items: center;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  max-width: 80px;\n  margin-right: 20px;\n  padding: 1.45rem 0;\n"], ["\n  max-width: 80px;\n  margin-right: 20px;\n  padding: 1.45rem 0;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(87);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(72);
	
	var palette = _interopRequireWildcard(_variables);
	
	var _semanticUiReact = __webpack_require__(46);
	
	__webpack_require__(973);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.section(_templateObject, palette.DARK_GRAY, palette.S_TYPO, palette.TURQUOISE);
	
	var ImgLogo = _styledComponents2.default.img(_templateObject2);
	
	var C_Header = function (_React$Component) {
	  _inherits(C_Header, _React$Component);
	
	  function C_Header() {
	    _classCallCheck(this, C_Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  C_Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      Header,
	      { className: "ui fluid container" },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: "/",
	            style: {
	              color: "white",
	              textDecoration: "none"
	            },
	            tabIndex: "0"
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Responsive,
	            { minWidth: 640 },
	            _react2.default.createElement(ImgLogo, { src: __webpack_require__(1208) })
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "typo__0" },
	            "Massimo Russo"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { className: "headerLinks" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/", activeClassName: "active", exact: true, tabIndex: "0" },
	          "Accueil"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/portfolio/", activeClassName: "active", exact: true, tabIndex: "0" },
	          "Portfolio"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/blogue/", activeClassName: "active", exact: true, tabIndex: "0" },
	          "Blogue"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/contact/", activeClassName: "active", exact: true, tabIndex: "0" },
	          "Contact"
	        )
	      )
	    );
	  };
	
	  return C_Header;
	}(_react2.default.Component);
	
	exports.default = C_Header;
	module.exports = exports["default"];

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.99dd35e7.png";

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n // background-color: ", ";\n"], ["\n // background-color: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(65);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(47);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _styledComponents = __webpack_require__(87);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(72);
	
	var palette = _interopRequireWildcard(_variables);
	
	__webpack_require__(725);
	
	var _semanticUiReact = __webpack_require__(46);
	
	__webpack_require__(974);
	
	var _Footer = __webpack_require__(607);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(608);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	/** Style **/
	
	/** Components **/
	
	
	var propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	/** Styled Components **/
	var Main_Container = _styledComponents2.default.div(_templateObject, palette.BG_MAIN);
	
	var HeaderContainer = _styledComponents2.default.header(_templateObject2);
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TemplateWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { visible: false }, _this.toggleVisibility = function () {
	      return _this.setState({ visible: !_this.state.visible });
	    }, _this.closeVisibility = function () {
	      return _this.setState({ visible: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TemplateWrapper.prototype.toggleBurger = function toggleBurger() {
	    var burgerMenu = document.querySelector("#burger").classList;
	    burgerMenu.toggle("is-active");
	  };
	
	  TemplateWrapper.prototype.closeBurger = function closeBurger() {
	    var burgerMenu = document.querySelector("#burger").classList;
	    burgerMenu.remove("is-active");
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var _this2 = this;
	
	    var visible = this.state.visible;
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        meta: [{ charSet: "utf-8" }, {
	          name: "description",
	          content: "Massimo Russo, développeur Front-End à Montréal"
	        }, {
	          name: "keywords",
	          content: "Front-end, developer, développeur, frontend, front end, montreal, canada"
	        }],
	        htmlAttributes: {
	          lang: "fr-CA"
	        }
	      }),
	      _react2.default.createElement(
	        HeaderContainer,
	        { className: "header" },
	        _react2.default.createElement(_Header2.default, null),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          {
	            name: "Toggle Menu",
	            type: "button",
	            id: "burger",
	            className: "C--menu-burger cmb__anim",
	            onClick: function onClick(event) {
	              _this2.toggleVisibility();
	              _this2.toggleBurger();
	            },
	            "aria-label": "Toggle Menu"
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "cmb__box" },
	            _react2.default.createElement("span", { className: "cmb__inner" })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Sidebar.Pushable,
	        { as: _semanticUiReact.Segment, basic: true },
	        _react2.default.createElement(
	          _semanticUiReact.Sidebar,
	          {
	            as: _semanticUiReact.Menu,
	            animation: "push",
	            direction: "top",
	            visible: visible,
	            inverted: true
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "ui container" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/", activeClassName: "active", exact: true },
	              _react2.default.createElement(
	                _semanticUiReact.Menu.Item,
	                { name: "home", className: "typo__6" },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: "home" }),
	                _react2.default.createElement(
	                  _semanticUiReact.Responsive,
	                  { minWidth: 640 },
	                  "Accueil"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/portfolio/", activeClassName: "active", exact: true },
	              _react2.default.createElement(
	                _semanticUiReact.Menu.Item,
	                { name: "desktop", className: "typo__6" },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: "desktop" }),
	                _react2.default.createElement(
	                  _semanticUiReact.Responsive,
	                  { minWidth: 640 },
	                  "Portfolio"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/blogue/", activeClassName: "active", exact: true },
	              _react2.default.createElement(
	                _semanticUiReact.Menu.Item,
	                { name: "newspaper", className: "typo__6" },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: "newspaper" }),
	                _react2.default.createElement(
	                  _semanticUiReact.Responsive,
	                  { minWidth: 640 },
	                  "Blogue"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/contact/", activeClassName: "active", exact: true },
	              _react2.default.createElement(
	                _semanticUiReact.Menu.Item,
	                { name: "mail", className: "typo__6" },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: "mail" }),
	                _react2.default.createElement(
	                  _semanticUiReact.Responsive,
	                  { minWidth: 640 },
	                  "Contact"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Sidebar.Pusher,
	          {
	            onClick: function onClick(event) {
	              _this2.closeVisibility();
	              _this2.closeBurger();
	            }
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true },
	            _react2.default.createElement(
	              Main_Container,
	              { className: "ui container fluid" },
	              children()
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 974:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	//BREAKPOINTS
	var XS = exports.XS = "min-width: 540px";
	var SM = exports.SM = "min-width: 640px";
	var MD = exports.MD = "min-width: 992px";
	var LG = exports.LG = "min-width: 1200px";
	var XL = exports.XL = "min-width: 1920px";
	var XXL = exports.XXL = "min-width: 2880px";
	
	// COLORS
	var PRIMARY = exports.PRIMARY = "#1b1b1b";
	var P_LIGHT = exports.P_LIGHT = "#424242";
	var P_DARK = exports.P_DARK = "#000000";
	var B_TYPO = exports.B_TYPO = "#ffffff";
	
	var TURQUOISE = exports.TURQUOISE = "#aed4ec";
	var DARK_TURQUOISE = exports.DARK_TURQUOISE = "";
	var FLASH_BLUE = exports.FLASH_BLUE = "#0096FF";
	
	var BROWN = exports.BROWN = "#8d6e63";
	var LIGHT_BROWN = exports.LIGHT_BROWN = "#be9c91";
	var DARK_BROWN = exports.DARK_BROWN = "#5f4339";
	
	var SECONDARY = exports.SECONDARY = "#0d47a1";
	var S_DARK = exports.S_DARK = "#002171";
	var S_LIGHT = exports.S_LIGHT = "#5472d3";
	var S_LIGHT_TYPO = exports.S_LIGHT_TYPO = "#000000";
	
	var THIRD = exports.THIRD = "#FC3F1D";
	var T_DARK = exports.T_DARK = "#c43c00";
	var T_LIGHT = exports.T_LIGHT = "#ff9e40";
	var T_TYPO = exports.T_TYPO = "#000000";
	var T_DARK_TYPO = exports.T_DARK_TYPO = "#ffffff";
	
	var BG_MAIN = exports.BG_MAIN = "#ffffff";
	
	var SHADOW = exports.SHADOW = "#e2e2e2";
	var DARK_GRAY = exports.DARK_GRAY = "#515151";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5e9f4fa75a8f44746e70.js